import { ORDERS } from "../../constants/apiEndPoints";
import httpRequest from "../../axios/index";
import { toast } from "react-hot-toast";

const GetSingleOrder = async (id = "", setLoading, SetOrderData) => {
  try {
    setLoading(true);
    const resp = await httpRequest.get(`${ORDERS}/${id}`);
    if (resp?.status === 200) {
      if (resp?.data.message === "Success") {
        SetOrderData(resp?.data?.data);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

const CancelOrderByID = async (id = "", setLoading) => {
  try {
    setLoading(true);
    const resp = await httpRequest.patch(`${ORDERS}/${id}/cancel`);
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

export { GetSingleOrder, CancelOrderByID };
